import { create } from "zustand";

interface SimulatorState {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

export const useSimulatorStore = create<SimulatorState>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  close: () => set({ open: false }),
}));
